'use strict';

customerZone

/**
 * Displays the shop-locator
 */
.component('shopLocator', {
    bindings: {},
    templateUrl: customerZone.fromBase('components/shop-locator/shop-locator.component.html'),
    controller: ['$log', '$q', '$scope', 'shopProvider', 'addressResolver', 'utils', function(
        $log, $q, $scope, shopProvider, addressResolver, utils) {
        var vm = this;

        var BELGIUM_BOUNDS = [
            {lat: 51.590469, lng: 2.372979},
            {lat: 51.624584, lng: 5.267877},
            {lat: 50.369732, lng: 6.767510},
            {lat: 49.260368, lng: 5.701837},
            {lat: 50.642235, lng: 2.296075}
        ];

        vm.near = '';
        vm.resultLimit = 20;
        vm.inBounds = true;
        vm.services = {
            topup: true,
            postpaid: false,
            prepaid: false
        };
        vm.searchCriteria = {};

        var allShops = [];

        vm.updateSearch = function(){
            vm.inBounds = true;
            vm.searchCriteria = angular.copy(vm.services);
            vm.selection = undefined;
            return addressResolver.resolve(addCountry(vm.near), BELGIUM_BOUNDS)
                .then(function(coordinates){
                    var locations = allShops;
                    locations = locations.filter(filterServices);
                    locations = sortByDistance(locations, coordinates);
                    locations = clip(locations, vm.resultLimit);
                    locations = label(locations);
                    vm.locations = locations;
                })
                .catch(function(){
                    var locations = allShops;
                    locations = locations.filter(filterServices);
                    locations = label(locations);
                    vm.locations = locations;
                    // we only consider it an 'issue' if the search-field was not blank.
                    vm.inBounds = !!/^\s*$/.exec(vm.near);
                });
        };

        var filterServices = function(location){
            for (var key in vm.services){
                if (vm.services.hasOwnProperty(key) && vm.services[key])
                    if (!location['service_'+key]) return false;
            }
            return true;
        };

        var sortByDistance = function(locations, from) {

            /**
             * Calculates the distance between two latlng locations in km.
             * @see http://www.movable-type.co.uk/scripts/latlong.html
             *
             * Shamelessly stolen from
             * https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js
             */
            var calcDistance = function(p1, p2) {
                if (!p1 || !p2) {
                    return 0;
                }

                var R = 6371; // Radius of the Earth in km
                var dLat = (p2.lat - p1.lat) * Math.PI / 180;
                var dLon = (p2.lng - p1.lng) * Math.PI / 180;
                var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) *
                    Math.sin(dLon / 2) * Math.sin(dLon / 2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                var d = R * c;
                return d;
            };

            var results = [];
            locations.forEach(function(location){
                var newEntry = Object.create(location);
                newEntry.distance = calcDistance(from, newEntry.coordinates);
                results.push(newEntry);
            });

            results.sort(function(a, b){ return a.distance - b.distance; });
            return results;
        };

        /**
         * Clip an array to the given size
         */
        var clip = function(entries, limit){
            return entries.slice(0, limit);
        };

        /**
         * Assign a label from A-Z to the given entries, if the size is small enough to do so.
         */
        var label = function(entries){
            var labels = entries.length <= 26 ? 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('') : null;

            return entries.map(function(entry, index){
                var result = Object.create(entry);
                result.label = labels ? labels[index] : null;
                return result;
            });
        };

        var addCountry = function(location){
            if (/^\s*\d\d\d\d\s*$/.exec(location))
                return location + ', Belgium';
            else
                return location;
        };

        vm.locations = label(allShops);

        shopProvider.getShops()
            .then(function(shops){
                allShops = shops.filter(function(location){
                    //remove entries that have null for coordinates
                    return location.coordinates && location.coordinates.lat;
                });
                vm.locations = label(allShops);
            })
            .catch(function(error){
                $log.error('Failed to load shops', error);
                utils.showError();
            });
    }],
    controllerAs: 'vm'
});
